import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { SkillsMenuContent } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/SkillsMenuContent.js';
import { useAskInputSkills } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/hooks/useAskInputSkills.js';
import { usePluginsNavigationHrefs } from '#pplx/frontend/apps/ask/connectors/hooks/usePluginsNavigationHrefs.js';
import { getSkillDisplayDescription, getSkillDisplayName, } from '#pplx/frontend/apps/ask/skill-cards/skillDisplay.js';
import { useSelectableSkills } from '#pplx/frontend/apps/ask/skills/hooks/useSelectableSkills.js';
import { useDebouncedValue } from '#pplx/frontend/common/hooks/useDebouncedValue.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { memo, useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
const SKILLS_LIMIT = 100;
export const ComputerModeMenuItems = memo(function ComputerModeMenuItems({ collectionUuid, skillMentionEditorRef, onMenuClose }) {
    const { manageSkills } = usePluginsNavigationHrefs();
    const { isMobileStyle } = useAetherContext();
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebouncedValue(searchQuery, 150);
    const skillsProps = useAskInputSkills({
        showSkills: true,
        lexicalEditorRef: skillMentionEditorRef,
        collectionUuid,
    });
    const { skills, isLoading } = useSelectableSkills({
        app: 'computer',
        limit: SKILLS_LIMIT,
        enabled: true,
        collectionUuid,
    });
    const handleSkillSelect = useCallback((skill) => {
        if (!skillsProps.showSkills)
            return;
        skillsProps.onSkillSelect(skill);
        onMenuClose();
    }, [onMenuClose, skillsProps]);
    const filteredSkills = useMemo(() => {
        const query = debouncedSearchQuery.trim().toLowerCase();
        if (!query)
            return skills;
        return skills.filter((skill) => skill.name.toLowerCase().includes(query) ||
            skill.description.toLowerCase().includes(query) ||
            getSkillDisplayName(skill).toLowerCase().includes(query) ||
            getSkillDisplayDescription(skill).toLowerCase().includes(query));
    }, [skills, debouncedSearchQuery]);
    return (_jsxs(_Fragment, { children: [_jsx(SkillsMenuContent, { searchQuery: searchQuery, setSearchQuery: setSearchQuery, filteredSkills: filteredSkills, isLoading: isLoading, onSkillSelect: handleSkillSelect }), _jsxs(DropdownMenu.Footer, { children: [!isMobileStyle && _jsx(DropdownMenu.Separator, {}), _jsx(DropdownMenu.LinkItem, { leadingAccessory: _jsx(Icon, { icon: $icon('settings'), size: "small" }), href: manageSkills, target: "_blank", rel: "noopener", children: _jsx(FormattedMessage, { defaultMessage: "Manage skills", description: "Footer link in the skills menu that navigates to the skills management page", id: "bd55b5d9f0" }) })] })] }));
});
//# sourceMappingURL=ComputerModeMenuItems.js.map